import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

interface IDevice {
  deviceId: string;
  kind: MediaDeviceKind;
  label: string;
}

interface IMediaDevicesPresenterProps {
  deviceKind: MediaDeviceKind;
  onCurrentDeviceChanged: (deviceId: string, needToPublish?: boolean) => void;
  deviceId: string | null;
}

export interface IMediaDevicesPresenter {
  devices: IDevice[];
  currentDeviceId: string | null;
  setCurrentDeviceId(deviceId: string): void;
  getDevices(devices: MediaDeviceInfo[]): void;
}

export const useMediaDevicesPresenter = (
  props: IMediaDevicesPresenterProps
): IMediaDevicesPresenter => {
  const presenter = useLocalObservable<IMediaDevicesPresenter>(() => ({
    devices: [],
    currentDeviceId: props.deviceId,

    getDevices(devices: MediaDeviceInfo[]): void {
      const mediaDevices: IDevice[] = [];

      devices.forEach((device) => {
        const mappedDevice: IDevice = {
          deviceId: device.deviceId,
          kind: device.kind,
          label: device.label,
        };

        if (mappedDevice.kind === props.deviceKind && mappedDevice.deviceId !== 'default') {
          mediaDevices.push(mappedDevice);
        }
      });
      presenter.devices = mediaDevices;
    },

    setCurrentDeviceId(deviceId: string): void {
      presenter.currentDeviceId = deviceId;
      props.onCurrentDeviceChanged(deviceId, true);
    },
  }));

  useEffect(() => {
    if (props.deviceId && props.deviceId !== presenter.currentDeviceId) {
      presenter.currentDeviceId = props.deviceId;
    }
  }, [props.deviceId]);
  return presenter;
};
